// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import BonusesModal from '../BonusesModal/BonusesModal';

import style from './AwardCounter.scss';
import icons from '../../../../assets/styles/icons.scss';
import awardBadge from '../../../../assets/img/flight/award-badge.png';

import type { TravelerReward } from '../../duck';

type Props = {
  +travelerReward?: TravelerReward;
  +isFetchingReward?: boolean;
};

type State = {
  bonusesModalVisible: boolean;
};

const MAX_PRODUCTS = 50;

export default class AwardCounter extends Component<Props, State> {
  state = {
    bonusesModalVisible: false,
  };

  handleOpenModal = () => {
    this.setState({
      bonusesModalVisible: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      bonusesModalVisible: false,
    });
  };

  render() {
    const { travelerReward, isFetchingReward } = this.props;
    const { bonusesModalVisible } = this.state;
    return (
      <Fragment>
        {(isFetchingReward || !travelerReward) &&
        <section className={classNames(style.awardCounterWrap, style.loading)}>
          <div className={style.square}/>
          <div className={style.rectangles}>
            <div className={style.rectangle}/>
            <div className={style.rectangle}/>
          </div>
        </section>}
        {!!travelerReward && travelerReward.reservationCount < MAX_PRODUCTS && !isFetchingReward &&
        <section className={style.awardCounterWrap}
                 onClick={this.handleOpenModal}>
          <div className={style.awardBadgeWrap}>
            <img src={awardBadge}
                 alt="award-badge"
                 className={style.awardBadge}/>
          </div>
          <section className={style.content}>
            <FormattedMessage id="awardCounter.bonusesProgress">{
              txt => <p>{txt}</p>
            }</FormattedMessage>
            <FormattedMessage id="awardCounter.orders">{
              txt => <p className={style.ordersText}>{txt}</p>
            }</FormattedMessage>
            <p className={style.productsCount}>{`${travelerReward.progress}/${travelerReward.total}`}</p>
            <section className={style.productsCounter}>
              <article style={{ width: `${Math.round((travelerReward.progress / travelerReward.total) * 100)}%` }}/>
              <span className={style.productsDot}
                    style={{ left: `${Math.round((travelerReward.progress / travelerReward.total) * 100)}%` }}/>
            </section>
          </section>
          <i className={classNames(icons.iconChevronRightMedium, style.chevron)}/>
        </section>}
        {!!travelerReward && travelerReward.reservationCount >= MAX_PRODUCTS && !isFetchingReward &&
        <section className={style.awardCounterWrap}
                 onClick={this.handleOpenModal}>
          <div className={style.awardBadgeWrap}>
            <img src={awardBadge}
                 alt="award-badge"
                 className={style.awardBadge}/>
          </div>
          <FormattedMessage id="awardCounter.missionsCompleted">{
            txt => <p>{txt}</p>
          }</FormattedMessage>
        </section>}
        {!!travelerReward &&
        <BonusesModal open={bonusesModalVisible}
                      handleClose={this.handleCloseModal}
                      travelerReward={travelerReward}/>}
      </Fragment>);

  }
}

AwardCounter.propTypes = {
  travelerReward: PropTypes.object,
  isFetchingReward: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/flight/components/AwardCounter/AwardCounter.jsx